import charts from '../charts.js';
import technicalsChart from './technicals.js';

export default function({ id, data, config, dates, defaults, earningsData }) {
	defaults = {
		defaultSeries: 'candlesticks',
		defaultOverlays: [ 'EMA20', 'SMA50' ],
		defaultIndicators: [ 'ADL' ],
		periodGrouping: 'daily',

		... defaults,
	}

	return technicalsChart({ id, data, config, dates, defaults, earningsData });
}
